import {
	addDefault,
	buildAddOnField
} from "../add-on-field";

export function createDateField(
	schemaFormProvider,
	sfPathProvider,
	format,
	schemaTypes,
	template
) {
	return function dateField(name, schema, options) {
		if(schema.format !== format || !schemaTypes.includes(schema.type)) {
			return undefined;
		}

		const field = buildAddOnField(
			schemaFormProvider,
			sfPathProvider,
			name,
			schema,
			options,
			format,
			template
		);
		field.schema = schema.type === format
			? { ...schema, type: "string" }
			: schema;

		return field;
	};
}

export function dateTimeAddOn(schemaFormDecoratorsProvider, sfBuilderProvider, schemaFormProvider, sfPathProvider) {
	const dateTimeField = createDateField(
		schemaFormProvider,
		sfPathProvider,
		"datetime",
		["datetime", "string"],
		"./wrapper.html"
	);

	addDefault(schemaFormProvider, "datetime", dateTimeField);
	addDefault(schemaFormProvider, "string", dateTimeField);

	schemaFormDecoratorsProvider.defineAddOn(
		"bootstrapDecorator",           	// Name of the decorator you want to add to.
		"datetime",                      		// Form type that should render this add-on
		"./templates/datetime/wrapper.html",  		// Template name in $templateCache
		sfBuilderProvider.stdBuilders   	// List of builder functions to apply.
	);
}

export function dateOnlyAddOn(schemaFormDecoratorsProvider, sfBuilderProvider, schemaFormProvider, sfPathProvider) {
	const dateField = createDateField(
		schemaFormProvider,
		sfPathProvider,
		"date",
		["date", "string"],
		"./dateOnlyWrapper.html"
	);

	addDefault(schemaFormProvider, "date", dateField);
	addDefault(schemaFormProvider, "string", dateField);

	schemaFormDecoratorsProvider.defineAddOn(
		"bootstrapDecorator",           	// Name of the decorator you want to add to.
		"date",                      		// Form type that should render this add-on
		"./templates/datetime/dateOnlyWrapper.html",  		// Template name in $templateCache
		sfBuilderProvider.stdBuilders   	// List of builder functions to apply.
	);
}
